import kotlin.String

internal object CLRDConfig {
  public val APPLICATION_ID: String = "1:1020439612670:web:f1d26dd8f321bd4e8aa9af"

  public val API_KEY: String = "AIzaSyAzKbn3unQBlIVOtAsRWSmz5FcVCmiYFUY"
}
